import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=33578f8a&scoped=true"
import script from "./Case.vue?vue&type=script&lang=js"
export * from "./Case.vue?vue&type=script&lang=js"
import style0 from "./Case.vue?vue&type=style&index=0&id=33578f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33578f8a",
  null
  
)

export default component.exports